import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

const getVisitorId = (): string => {
  const key = 'aura_vid';
  let vid = localStorage.getItem(key);
  if (!vid) {
    vid = crypto.randomUUID();
    localStorage.setItem(key, vid);
  }
  return vid;
};

const getSessionId = (): string => {
  const key = 'aura_sid';
  let sid = sessionStorage.getItem(key);
  if (!sid) {
    sid = crypto.randomUUID();
    sessionStorage.setItem(key, sid);
  }
  return sid;
};

const getDeviceType = (): string => {
  const ua = navigator.userAgent;
  if (/tablet|ipad|playbook|silk/i.test(ua)) return 'tablet';
  if (/mobile|iphone|ipod|android|blackberry|opera mini|iemobile/i.test(ua)) return 'mobile';
  return 'desktop';
};

const getSource = (referrer: string): string => {
  if (!referrer) return 'Direct';
  try {
    const host = new URL(referrer).hostname.replace('www.', '');
    // Map common referrers
    if (host.includes('facebook.com') || host.includes('l.facebook.com') || host.includes('m.facebook.com')) return 'Facebook';
    if (host.includes('instagram.com') || host.includes('l.instagram.com')) return 'Instagram';
    if (host.includes('tiktok.com')) return 'TikTok';
    if (host.includes('google.com') || host.includes('google.')) return 'Google';
    if (host.includes('bing.com')) return 'Bing';
    if (host.includes('twitter.com') || host.includes('t.co') || host.includes('x.com')) return 'X/Twitter';
    if (host.includes('youtube.com')) return 'YouTube';
    if (host.includes('linkedin.com')) return 'LinkedIn';
    return host;
  } catch {
    return 'Direct';
  }
};

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Skip admin pages from tracking
    if (location.pathname.startsWith('/admin')) return;

    const track = async () => {
      try {
        const referrer = document.referrer || '';
        await (supabase.from('page_views') as any).insert({
          path: location.pathname,
          referrer: referrer || null,
          user_agent: navigator.userAgent,
          session_id: getSessionId(),
          visitor_id: getVisitorId(),
          device_type: getDeviceType(),
          source: getSource(referrer),
        });
      } catch (e) {
        // Silent fail
      }
    };

    track();
  }, [location.pathname]);
};
